import { h } from 'preact'
import Icon from '../assets'
import { t } from '../../libs/translationsUtils/translations'

interface Props {
  onClick: () => void,
  className?: string,
  numberOfVotes: number,
  currentUserVoted: boolean,
  displayText?: boolean
}

const TopicVote = ({ onClick, className = '', numberOfVotes, currentUserVoted, displayText }: Props) => {
  return (
    <button className={`thread-meta-item btn--toggle thread-meta-item--vote qa-topic-meta-likes-icon ${currentUserVoted ? 'preact_voted' : ''} ${className}`} onClick={onClick}>
      <span className='qa-topic-meta-likes-content'>{`${displayText ? t('Forum', 'upvote') : ''} ${numberOfVotes}`}</span>
      <Icon
        icon='triangle'
        width={10}
        height={8}
      />
    </button>
  )
}

export default TopicVote
